import { Suspense } from 'react'
import { LoadingScreen } from '../features/insights_hub/components/LoadingScreen/LoadingScreen'
import { ClusteringInsights } from '../features/insights_hub/components/ClusteringInsights/ClusteringInsights'
import { HookTextInsights } from '../features/insights_hub/components/HookTexts/HookTexts'
import { useGlobalState } from '../state/v2/store'

export function AdvancedInsights() {
  const brandId = useGlobalState((b) => b.brand?.map((brand) => brand.id).join(","))
  if (!brandId) {
    return <div>No brand selected</div>
  }
  return (
    <Suspense fallback={<LoadingScreen />}>
      <div className="flex flex-col gap-12">
        <div className="bg-offWhite py-12">
          <ClusteringInsights brandId={brandId} />
        </div>
        <HookTextInsights brandId={brandId} />
      </div>
    </Suspense>
  )
}
